import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

// 直接导入组件，避免懒加载可能导致的问题
import Activity from '../views/Activity.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: Activity,
    meta: {
      title: '',
      keepAlive: false,
    },
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: {
      title: '',
      keepAlive: false,
    }
  },
  {
    path: '/activity-poster',
    name: 'ActivityPoster',
    component: () => import('../views/poster/ActivityPoster.vue'),
    meta: {
      title: '活动海报',
      keepAlive: false,
    }
  },
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: '页面不存在',
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 更新页面标题
  document.title = `${to.meta.title || '集换社'}`;
  
  // 添加调试信息
  console.log('路由导航:', {
    to: {
      path: to.path,
      name: to.name,
      meta: to.meta,
      matched: to.matched.map(record => record.name)
    },
    from: {
      path: from.path,
      name: from.name
    }
  });
  
  // 这里可以添加权限控制等逻辑
  
  next();
});

// 全局后置守卫
router.afterEach((to, from) => {
  console.log('路由导航完成:', {
    to: {
      path: to.path,
      name: to.name
    },
    from: {
      path: from.path,
      name: from.name
    }
  });
});

export default router; 